import type React from 'react'

const IconFigma: React.FC = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.69922 3.2063C2.69922 1.60181 3.9707 0.300049 5.5752 0.300049H10.5703C12.1748 0.300049 13.4463 1.60181 13.4463 3.2063C13.4463 4.2356 12.9316 5.11353 12.1445 5.62817C12.9316 6.1731 13.4463 7.05103 13.4463 8.08032C13.4463 9.65454 12.1748 10.9563 10.5703 10.9563H10.5098C9.75293 10.9563 9.05664 10.6838 8.54199 10.1995V12.8938C8.54199 14.4983 7.20996 15.8 5.60547 15.8C4.00098 15.8 2.69922 14.5286 2.69922 12.9241C2.69922 11.8948 3.21387 11.0168 4.00098 10.5022C3.21387 9.95728 2.69922 9.07935 2.69922 8.08032C2.69922 7.05103 3.21387 6.1731 4.00098 5.62817C3.21387 5.11353 2.69922 4.2356 2.69922 3.2063ZM7.60352 6.11255H5.5752C4.51562 6.11255 3.6377 6.99048 3.6377 8.08032C3.6377 9.13989 4.48535 10.0178 5.5752 10.0178H7.60352V6.11255ZM8.54199 8.08032C8.54199 9.13989 9.41992 10.0178 10.5098 10.0178H10.5703C11.6299 10.0178 12.5078 9.13989 12.5078 8.08032C12.5078 6.99048 11.6299 6.11255 10.5703 6.11255H10.5098C9.41992 6.11255 8.54199 6.99048 8.54199 8.08032ZM5.5752 10.9563C4.48535 10.9866 3.6377 11.8342 3.6377 12.9241C3.6377 13.9836 4.51562 14.8616 5.60547 14.8616C6.69531 14.8616 7.60352 13.9836 7.60352 12.8938V10.9563H5.5752ZM5.5752 1.2688C4.51562 1.2688 3.6377 2.14673 3.6377 3.2063C3.6377 4.29614 4.51562 5.17407 5.5752 5.17407H7.60352V1.2688H5.5752ZM8.54199 5.17407H10.5703C11.6299 5.17407 12.5078 4.29614 12.5078 3.2063C12.5078 2.14673 11.6299 1.2688 10.5703 1.2688H8.54199V5.17407Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.4}
    />
  </svg>
)

export default IconFigma
